//设置微信分享的方法

import { getShareUrlApi } from '@/service/api-service';
import Mshare from "m-share/dist/m-share";
import { Toast } from "vant";

/**
 * @param {*} shareInfo 分享的父对象
 * @param {*} shareTitle 分享标题
 * @param {*} shareLink 分享链接
 * @param {*} shareDesc 分享描述
 * @param {*} shareImg 分享图片
 */
export async function shareUrl(shareInfo) {
    let title = '中国原创音乐作品数字出版平台'
    let sLink = window.config.homeUrl
    let sDesc = '人民音乐出版社编'
    let shareImg = window.config.shareConfig
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (shareInfo) {
        if (shareInfo.shareTitle) {
            title = shareInfo.shareTitle
        }
        if (shareInfo.shareLink) {
            sLink = shareInfo.shareLink
        }
        if (shareInfo.shareDesc) {
            sDesc = shareInfo.shareDesc
        }
        if (shareInfo.shareImg) {
            shareImg = shareInfo.shareImg
        }
    }


    let shareUrl = window.location.href;
    let params = {
        shareUrl: shareUrl
    };

    if (shareUrl.includes("refresh") && isIOS && shareUrl.includes("album")) {
        Toast.loading({
            message: '微信分享加载中...',
            forbidClick: true,
            duration: 0
        });
    } else if (!isIOS && shareUrl.includes("album") ) {
        Toast.loading({
            message: '微信分享加载中...',
            forbidClick: true,
            duration: 0
        });
    }

    let res = await getShareUrlApi(params);
    if (res.sign) {
        let sign = res.sign;
        Mshare.wxConfig({
            title: title,
            link: sLink,
            desc: sDesc,
            imgUrl: shareImg,
            wx: {
                appId: sign.appid, // 必填，公众号的唯一标识
                timestamp: sign.timestamp, // 必填，生成签名的时间戳
                nonceStr: sign.nonceStr, // 必填，生成签名的随机串
                signature: sign.signature // 必填，签名
            },
        })
        Toast.clear();
    } else {
        Toast.fail('分享加载失败');
    }
}


//原生微信分享
import wx from '../../../node_modules/weixin-js-sdk'
export async function wxShareUr(shareInfo) {
    console.log('shareInfo', shareInfo);

    let shareUrl = window.location.href;
    let params = {
        shareUrl: shareUrl
    };

    let title = '中国原创音乐作品数字出版平台'
    let sLink = window.config.homeUrl
    let sDesc = '专业音乐发布平台，原创作曲交流园地'
    let shareImg = window.config.shareConfig
    if (shareInfo) {
        if (shareInfo.shareTitle) {
            title = shareInfo.shareTitle
        }
        if (shareInfo.shareLink) {
            sLink = shareInfo.shareLink
        }
        if (shareInfo.shareDesc) {
            sDesc = shareInfo.shareDesc
        }
        if (shareInfo.shareImg) {
            shareImg = shareInfo.shareImg
        }
    }




    let res = await getShareUrlApi(params);
    if (res.sign) {
        let sign = res.sign;
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: sign.appid, // 必填，公众号的唯一标识
            timestamp: sign.timestamp, // 必填，生成签名的时间戳
            nonceStr: sign.nonceStr, // 必填，生成签名的随机串
            signature: sign.signature,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
        });

        wx.ready(() => {
            const shareData = {
                title: title,
                desc: sDesc,
                link: sLink,
                imgUrl: shareImg
            }
            wx.updateAppMessageShareData(shareData)
            wx.updateTimelineShareData(shareData)

        })

    }
}
